"use client";

import { XIcon } from "@/components/icons/XIcon";
import { useTranslations } from "@/i18n/client";
import { Button } from "../Button";
import {
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalRoot,
	ModalViewport,
} from "../Drawer";
import styles from "./GeoPopup.module.css";
import { useGeoPopup } from "./hooks";

export const GeoPopup = () => {
	const {
		changeCountry,
		close,
		shouldOpen,
		browserCountryInfo,
		currentCountryInfo,
	} = useGeoPopup();
	const t = useTranslations();

	return (
		<ModalRoot
			open={shouldOpen}
			onOpenChange={() => {
				close();
			}}
		>
			<ModalViewport className={styles.viewport}>
				<XIcon
					height={9}
					width={9}
					className={styles.close}
					onClick={() => close()}
				/>
				<ModalContent className={styles.content}>
					<ModalHeader asChild>
						<h3 className={styles.title}>
							{t("geo.title", {
								country: browserCountryInfo?.name,
							})}
						</h3>
					</ModalHeader>
					<p className={styles.description}>{t("geo.description")}</p>
					<ModalFooter>
						<div className={styles.buttons}>
							<Button onClick={() => changeCountry(false)}>
								{t("geo.shopCountry", {
									country: t(`countries.${browserCountryInfo?.name}`),
								})}
							</Button>
							<button onClick={() => close()} className={styles.link}>
								{t("geo.close")}
							</button>
						</div>
					</ModalFooter>
				</ModalContent>
			</ModalViewport>
		</ModalRoot>
	);
};
